module.exports = __webpack_public_path__ + "img/masterAdmins.dfc90857.svg";